import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../services/auth/auth.service';
import { CartService } from '../../services/cart.service';
import { GlobalStateService } from '../../services/global-state.service';
import { MainCategoryService } from '../../services/main-category.service';
import { SubCategoryService } from '../../services/sub-category.service';
import { forkJoin, of, Subject, Subscriber, Subscription } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  finalize,
  map,
  switchMap,
  take,
  tap
} from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProductsService } from '../../services/products.service';
import { SharedService } from '../../../shared/services/shared.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    InputTextModule,
    ButtonModule,
    FormsModule,
    AutoCompleteModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})

export class HeaderComponent implements OnInit {
  isMenuOpen = false;
  isDropdownOpen = false;
  cartItemCount: any;
  userId = '';
  isShowHeader = true;
  searchQuery = '';

  selectedProduct: any;

  search$ = new Subject<string>();
  isLoading = false;
  filteredProducts: any[] = [];
  errorMsg = '';



  menuItems: any[] = [];
  subcategories: any[] = [];

  activeCategoryId: number | null = null;
  activeFilterCategoryId?: number;



  currencies = [
    { label: 'EUR', value: 'eur' }
  ];
  selectedCurrency = 'usd';

  showClassification = false;



  socialIcons = [
    { src: 'assets/img/icons/twitter.svg', alt: 'Twitter' },
    { src: 'assets/img/icons/facebook.svg', alt: 'Facebook' },
    { src: 'assets/img/icons/pinterest.svg', alt: 'Pinterest' },
    { src: 'assets/img/icons/reddit.svg', alt: 'Reddit' },
    { src: 'assets/img/icons/youtube.svg', alt: 'Youtube' },
    { src: 'assets/img/icons/instagram.svg', alt: 'Instagram' }
  ];
  initValue: any;
  showCategory: boolean = true;


  isHomePage = false;
  orderId: string | null = null;



  constructor(
    public readonly authService: AuthService,
    private readonly router: Router,
    private readonly cartService: CartService,
    private readonly globalStateService: GlobalStateService,
    private readonly categoryService: MainCategoryService,
    private readonly subcategoryService: SubCategoryService,
    private readonly productsService: ProductsService,
    public sharedService: SharedService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.isHomePage = e.urlAfterRedirects === '/home';
        console.log(this.isHomePage);
        if(this.isHomePage) {
          localStorage.removeItem('activeCategory');
          localStorage.removeItem('activeSeletedCategory');
        }
        // Re-apply active logic when route changes
        if (this.menuItems?.length) {
          this.applyActiveFromRoute();
        }
      });

    const userInfo = this.authService.getUserInfo();
    this.userId = userInfo?.userId || '';

    this.globalStateService.headerVisibleSubject.subscribe((data: boolean) => {
      this.isShowHeader = data;
    });



    if (this.authService.isAuthenticated() && this.userId) {


      this.cartService.cartItemCount$.subscribe(count => {
        this.cartItemCount = count;
      });

      // On initial load, fetch from localStorage or backend
      const storedCount = localStorage.getItem('countOfCart');
      if (storedCount && this.cartItemCount > 0) {
        this.cartService.updateCartItemCount(+storedCount);
      } else {
        this.cartService.getCartItem(this.userId).subscribe(res => {
          const count = res.items.length;
          this.cartService.updateCartItemCount(count);
          localStorage.setItem('countOfCart', count.toString());
        });
      }
    }




    this.loadCategories();

    this.globalStateService.activeCategory$.subscribe((categoryId: any) => {
      this.menuItems.forEach(item => {
        item.active = item.id === categoryId;
      });
    });




    this.search$
  .pipe(
    distinctUntilChanged(),
    switchMap(query => {
      this.isLoading = true;
      this.errorMsg = '';

      return this.productsService.getSearchResults(query).pipe(
        catchError(() => {
          this.errorMsg = 'Search failed. Please try again.';
          return of([]);
        }),
        finalize(() => {
          this.isLoading = false;
        })
      );
    })
  )
  .subscribe(results => {
    this.filteredProducts = results ?? [];
  });


    if (this.router.url.includes('/cart') || this.router.url.includes('/orders')) {
      this.showCategory = false;
    } else {
      this.showCategory = true
    }



    // Keep header highlight in sync with global state everywhere
    this.globalStateService.activeCategory$.subscribe((id) => {
      this.activeCategoryId = id ?? null;
      // Optional: if you still want to keep item.active flags for other logic
      this.menuItems.forEach(item => item.active = item.id === id);
    });


    this.route.queryParamMap.subscribe(params => {
      this.orderId = params.get('orderId');
      this.updateCategoryVisibility();
    });

    this.router.events.subscribe(() => {
      this.updateCategoryVisibility();
    });




  }


  updateCategoryVisibility() {
    const currentPath = this.router.url;
    if ((this.orderId && currentPath.includes('successfull')) || (currentPath.includes('canceled'))) {
      this.showCategory = false;
    } else {
      this.showCategory = true;
    }
  }



  onComplete(e: { originalEvent: Event; query: string }) {
    this.search$.next(e.query);
  }

  productRedirection(event: any) {

    const id = event?.value?.id ?? event?.id;
    if (!id) return;

    this.globalStateService.setActiveCategory(id ?? null);
    this.globalStateService.setSelectedProductId(id);

    if (this.router.url === '/product-overview') {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/product-overview']);
      });
    } else {
      this.router.navigate(['/product-overview']);
    }
  }

  updateCartItem() {
    this.cartItemCount = localStorage.getItem('countOfCart')
    console.log(this.cartItemCount);
  }




  loadCategories(): void {
    const desiredOrder = [
      'Laptops',
      'Mobiles',
      'Monitors',
      'Peripheral Devices',
      'Welcome Kit',
      'Office furniture',
      'Internet Connectivity'
    ];

    this.categoryService.getCategories().subscribe((response: any[]) => {
      const categoryChecks = response.map((item: { id: any; categoryName: any; showClassification: boolean }) =>
        this.subcategoryService.getSubcategoriesByCategory(item.id).pipe(
          map((subs: any) => ({
            id: item.id,
            label: item.categoryName,
            active: false,
            hasSubcategories: subs.length > 0,
            showClassification: item.showClassification
          }))
        )
      );

      forkJoin(categoryChecks).subscribe(menuItemsWithSubs => {
        // ✅ Sort according to desired order
        this.menuItems = menuItemsWithSubs.sort((a, b) => {
          const indexA = desiredOrder.indexOf(a.label);
          const indexB = desiredOrder.indexOf(b.label);
          return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
        });

        this.applyActiveFromRoute();
        this.updateShowClassification();
      });
    });
  }


  private applyActiveFromRoute(): void {
    // Clear all active states
    this.menuItems.forEach((i) => (i.active = false));

    if (this.isHomePage) {
      // On Home: nothing active
      return;
    }

    // On other pages: restore saved category if available
    const savedId = localStorage.getItem('header_cId');
    if (savedId) {
      const idNum = Number(savedId);
      const toActivate = this.menuItems.find((i) => i.id === idNum);
      if (toActivate) {
        toActivate.active = true;
        this.globalStateService.setActiveCategory(toActivate.id);
      }
    }
  }

  loadSubcategories(categoryId: number): void {
    this.subcategoryService.getSubcategoriesByCategory(categoryId).subscribe((response: any[]) => {
      this.subcategories = response;
    });
  }




  setActive(selectedItem: any): void {
    this.showCategory = !this.router.url.includes('/cart');

    // optional cleanup of old flags
    this.menuItems.forEach(item => item.active = false);
    selectedItem.active = true;

    // 🔑 this drives the header highlight everywhere
    this.globalStateService.setActiveCategory(selectedItem.id);
    console.log('==========>>>>SelectedItem', selectedItem);
    this.globalStateService.setSeletedActiveCategory(selectedItem);
    this.updateShowClassification();
    if (selectedItem.hasSubcategories) {
      this.loadSubcategories(selectedItem.id);
    } else {
      this.subcategories = [];
    }

    // do NOT use header_cId anymore; global state already persists to localStorage
    // localStorage.setItem('header_cId', selectedItem.id);
    setTimeout(() => {
      this.router.navigate(['/shop']);
      localStorage.setItem('resetClassifications', 'resetClassifications');
    }, 1000);
  }




  updateShowClassification(): void {
    const idFromStorage = localStorage.getItem('activeCategory');
    const id = idFromStorage ? Number(idFromStorage) : undefined;

    this.activeFilterCategoryId = id;

    const cat = this.menuItems.find(c => c.id === id);
    const flag = cat?.showClassification ?? false;

    // ✅ Update the shared signal (and persist if you want)
    this.sharedService.setShowClassification(flag);

    console.log('[Header] activeCategoryId:', id, 'showClassification:', flag);
  }





  navigateHome(): void {
    // Clear active category so no highlight on home page
    this.globalStateService.clearActiveCategory();
    this.router.navigate(['/home']);
  }



  navigateToSubcategory(subcategoryId: number): void {
    this.globalStateService.setActiveSubcategory(subcategoryId);
    this.router.navigate(['/shop']);
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  dropdownOpen(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    // this.showCategory = false;
  }

  ordersNavigate(): void {
    // this.isDropdownOpen = !this.isDropdownOpen;
    this.showCategory = false;
  }

  logout(): void {
    this.authService.logout();
    localStorage.removeItem('activeCategory');
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = (event.target as HTMLElement).closest('.user-dropdown-container');
    if (!clickedInside && this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }

  onSearch(query: string) {
    this.search$.next(query);
  }
  fetchProducts(query: string): any {
    this.isLoading = true;
    console.log('queryyyyyyy', query)
    this.productsService.getSearchResults(query).subscribe({
      next: (res) => {
        this.filteredProducts = [...res];
        this.isLoading = false;
      }
    })
  }


  submitSearch() {
    // If user selected an item object from AutoComplete, redirect
    if (this.selectedProduct && typeof this.selectedProduct === 'object') {
      this.productRedirection(this.selectedProduct);
      return;
    }

    // Otherwise treat it as a free-text search
    const q = typeof this.selectedProduct === 'string' ? this.selectedProduct.trim() : (this.searchQuery?.trim() || '');
    if (q) {
      // TODO: navigate to search results page with q
      // this.router.navigate(['/search'], { queryParams: { q } });
    }
  }


  clearSearch(): void {
    this.selectedProduct = '';
  }

}
